import * as React from 'react';
import './Arrow.scss';

interface IArrowProps {
  iconName: string;
  clickFunction(): void;
}

export const Arrow = (props: IArrowProps) => (
  <div
    className={`rp-arrow arrow rpds ${props.iconName}`}
    onClick={props.clickFunction}
  />
);

export default Arrow;
